(function (window, document) {
  "use strict";

  var DNB = window.DNB;

  // Mimari Kütüphane — library.min.js
  document.addEventListener("DOMContentLoaded", function () {
    DNB.safeInit("Library", function () { DNB.Library.init(); });
    DNB.safeInit("CatalogDownload", function () { DNB.CatalogDownload.init(); });
  });
})(window, document);
